import { Col, Row, Spin, Tabs } from 'antd';
import React, { useContext, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { MeetingApi } from '../apis/meeting-api';
import { MinutesApi } from '../apis/minutes-api';
import { Logger } from '../utilites/loglySetup';
import { AuthContext } from '../utilites/auth';
import { TaskApi } from '../apis/task-api';

enum RedirectPage {
  home,
  meetings,
  meetingDetail,
  minutes,
  documents,
  documentFolder,
  agenda,
  announcements,
  surveys,
  surveyEdit,
  surveyManage,
  activity,
  attendance,
  financials,
  notifications,
  help,
  users,
  userDetail,
  committees,
  committeeEdit,
  votes,
  voteEdit,
  voteResults,
  tasks,
  task,
  esign,
  esignEdit,
  settingsOrganization,
  settingsMeeting,
  settingsSurvey,
  settingsDocument,
  settingsSubscription,
  settingsInvoices,
  settingsMeetingLocations,
  settingsTwoFactor,
  settingsMessaging,
  redirect,
  gabii,
  unknown
}

const RedirectHandler = () => {
    const { profile } = useContext(AuthContext);
    const history = useHistory();
    const location = useLocation();
    useEffect(() => {

      let paths = location.pathname.split("/")

      let type = typeForRedirect()
      handleType(type,0)
      
    }, [])


    const typeForRedirect = () => {

      //Company/1082/Survey/Manage?surveyId=4235
      let paths = location.pathname.split("/")
      let params = new URLSearchParams(location.search)

      if(paths.length < 4) {
        if(paths.includes("Redirect") || paths.includes("redirect"))
          return RedirectPage.redirect
        else
          return RedirectPage.unknown
      }

      if(paths[3].toLowerCase() == "home") {
        return RedirectPage.home
        
      } else if(paths[3].toLowerCase() == "meeting") {

        if(paths.length >= 5 && paths[4].toLowerCase() == "meetingdetail") {
          let id = parseInt(paths[5])
          if(id > 0) {
            return RedirectPage.meetingDetail
          }
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "agenda") {
          let id = parseInt(paths[5])
          if(id > 0) {
            return RedirectPage.agenda
          }
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "task") {
          let id = parseInt(paths[5])
          if(id > 0) {
            return RedirectPage.task
          }
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "attendancereporting") {
          return RedirectPage.attendance
        }

        return RedirectPage.meetings

      } else if(paths[3].toLowerCase() == "meeting" && paths[4].toLowerCase() == "agenda") {

        if(paths.length < 5) return RedirectPage.unknown

        //Old agenda
        let id = parseInt(paths[5])
        if(id > 0) {
          return RedirectPage.agenda
        }

      } else if(paths[3].toLowerCase() == "user") {

        if(paths.length >= 5 && paths[4].toLowerCase() == "edit") {
          let id = parseInt(paths[5])
          if(id > 0) return RedirectPage.userDetail
        }

        return RedirectPage.users

      } else if(paths[3].toLowerCase() == "survey") {

        if(paths.length >= 5 && paths[4].toLowerCase() == "edit") {
          let id = parseInt(paths[5])
          if(id > 0) return RedirectPage.surveyEdit
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "manage") {
          let param = params.get("surveyId");
          if(param && parseInt(param) > 0) return RedirectPage.surveyManage
        }

        return RedirectPage.surveys

      } else if(paths[3].toLowerCase() == "poll") {

        if(paths.length >= 5 && paths[4].toLowerCase() == "editpoll") {
          let id = parseInt(paths[5])
          if(id > 0) return RedirectPage.voteEdit
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "pollresults") {
          let id = parseInt(paths[5])
          if(id > 0) return RedirectPage.voteResults
        }

        return RedirectPage.votes

      } else if(paths[3].toLowerCase() == "approval") {

        if(paths.length >= 5 && paths[4].toLowerCase() == "edit") {
          let id = parseInt(paths[5])
          if(id > 0) return RedirectPage.esignEdit
        }

        return RedirectPage.esign

      } else if(paths[3].toLowerCase() == "document") {

        if(paths.length >= 5 && paths[4].toLowerCase() == "index") {
          let id = parseInt(paths[5])
          if(id > 5) return RedirectPage.documentFolder
        }

        return RedirectPage.documents
      } else if(paths[3].toLowerCase() == "committee") {

        if(paths.length >= 5 && paths[4].toLowerCase() == "edit") {
          let param = params.get("committeeId");
          if(param && parseInt(param) > 0) return RedirectPage.committeeEdit
        } 

        return RedirectPage.committees

      } else if(paths[3].toLowerCase() == "settings") {

        if(paths.length >= 5 && paths[4].toLowerCase() == "companydetails") {
          return RedirectPage.settingsOrganization
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "meetingsettings") {
          return RedirectPage.settingsMeeting
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "surveysettings") {
          return RedirectPage.settingsSurvey
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "documentsettings") {
          return RedirectPage.settingsDocument
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "subscription") {
          return RedirectPage.settingsSubscription
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "invoices") {
          return RedirectPage.settingsInvoices
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "meetinglocations") {
          return RedirectPage.settingsMeeting
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "twofactorsettings") {
          return RedirectPage.settingsTwoFactor
        } else if(paths.length >= 5 && paths[4].toLowerCase() == "messagingsettings") {
          return RedirectPage.settingsMessaging
        }

        return RedirectPage.unknown

      } else if(paths[3].toLowerCase() == "support") {
        return RedirectPage.help
      } else if(paths[3].toLowerCase() == "minute") {
        return RedirectPage.minutes
      } else if(paths[3].toLowerCase() == "notification") {
        return RedirectPage.notifications
      } else if(paths[3].toLowerCase() == "announcement") {
        return RedirectPage.announcements
      } else if(paths[3].toLowerCase() == "financial") {
        return RedirectPage.financials
      } else if(paths[3].toLowerCase() == "task") {
        return RedirectPage.tasks
      } else if(paths[3].toLowerCase() == "reporting") {
        if(paths.length >= 5 && paths[4].toLowerCase() == "activityreporting") {
          return RedirectPage.activity
        } 
      } else if(paths[3].toLowerCase() == "redirect") {
        return RedirectPage.redirect
      }

      return RedirectPage.unknown
    }

    const handleType = (type:RedirectPage, forceId:number) => {
      let paths = location.pathname.split("/")
      var path = `/company/${profile?.companyId}`
      switch(type) {
        case RedirectPage.meetings:
          path += `/meetings`
          break
        case RedirectPage.meetingDetail:
          let meetingId = parseInt(paths[5])
          path += `/meetings/${meetingId}`
          break
        case RedirectPage.minutes:
          let minuteId = parseInt(paths[5])
          getMinutesForId(minuteId)
          return
        case RedirectPage.documents:
          path = '/documents'
          break
        case RedirectPage.documentFolder:
          let folderId = parseInt(paths[5])
          path += `/documents/${folderId}`
          break
        case RedirectPage.agenda:
          let agendaId = parseInt(paths[5])
          let tasks = paths.length > 5 && paths[6] == "tasks"
          getAgendaForSection(agendaId,tasks)
          return
        case RedirectPage.task: 
          let taskId = parseInt(paths[5])
          getTask(taskId)
          return
        case RedirectPage.announcements:
          path += '/news'
          break
        case RedirectPage.surveys:
          path += '/surveys'
          break
        case RedirectPage.gabii:
            path += '/gabii'
            break
        case RedirectPage.surveyEdit:
          let surveyEditId = parseInt(paths[5])
          path += `/surveys/edit/${surveyEditId}`
          break
        case RedirectPage.surveyManage:
          let surveyId = parseInt(paths[5])
          path += `/surveys/${surveyId}`
          break
        case RedirectPage.activity:
          path += '/reports/activity'
          break
        case RedirectPage.attendance:
          path += '/reports/attendance'
          break
        case RedirectPage.financials:
          path += '/financials'
          break
        case RedirectPage.notifications:
          path += '/notifications'
          break
        case RedirectPage.help:
          path += '/help'
          break
        case RedirectPage.users:
          path += '/users'
          break
        case RedirectPage.userDetail:
          let userId = parseInt(paths[5])
          path += `/users/edit/${userId}`
          break
        case RedirectPage.committees:
          path += '/committees'
          break
        case RedirectPage.committeeEdit:
          let committeeId = parseInt(paths[5])
          path += `/committees/edit/${committeeId}`
          break
        case RedirectPage.votes:
          path += '/votes'
          break
        case RedirectPage.voteEdit:
          let editVote = parseInt(paths[5])
          path += `/votes/edit/${editVote}`
          break
        case RedirectPage.voteResults:
          let voteId = parseInt(paths[5])
          path += `/votes/${voteId}`
          break
        case RedirectPage.tasks:
          path += `/tasks`
          break
        case RedirectPage.esign:
          path += `/esignatures`
          break
        case RedirectPage.esignEdit:
          let esignId = parseInt(paths[5])
          path += `/esignatures/${esignId}`
          break
        case RedirectPage.settingsOrganization:
          path += '/settings/organization'
          break
        case RedirectPage.settingsMeeting:
          path += '/settings/meeting'
          break
        case RedirectPage.settingsSurvey:
          path += '/settings/survey'
          break
        case RedirectPage.settingsDocument:
          path += '/settings/document'
          break
        case RedirectPage.settingsSubscription:
          path += '/settings/subscription'
          break
        case RedirectPage.settingsInvoices:
          path += '/settings/subscription/invoices'
          break
        case RedirectPage.settingsMeetingLocations:
          path += '/settings/meeting'
          break
        case RedirectPage.settingsTwoFactor:
          path += '/settings/twofactor'
          break
        case RedirectPage.settingsMessaging:
          path += '/settings/memberapp'
          break
        case RedirectPage.redirect:
          let params = new URLSearchParams(location.search)
          if(params.has("key")) {
            path = handleRedirectUrl(params.get("company"),params.get("key"),params.get("value"))
          } else {
            if(!profile) {
              path = `/login${params.toString()}`
            } else if(params.get('user') == profile.userName) {
              path = `/company/${params.get('company')}`
            }
          }
          break
        case RedirectPage.unknown:
          break
      }

      window.location.href = path
    }

    const handleRedirectUrl = (company:string,key:string,value:string) => {
      let baseURL = `/company/${company}`
      switch (key) {
        case "dashboard":
            return baseURL + "/home/index";
        case "meeting":

            if (value == "index") {
                return baseURL + "/meeting/index";
            } else {
                return baseURL + "/meeting/meetingdetail/" + value;
            }
        case "proposed":
           return baseURL + "/meeting/index?prop=true&id=" + value;
        case "agenda":
           return baseURL + "/meeting/agenda/" + value;
        case "financials":
           return baseURL + "/financial/index?fileId=" + value;
        // case "minutes":
        //    return baseURL + "/minutes/index?fileId=" + value;
        case "announcement":
           return baseURL + "/home/index?fileId=" + value;
        case "poll":
           return baseURL + "/home/index?pollId=" + value;
        case "documents":
           return baseURL + "/document/index";
        case "directory":
           return baseURL + "/directory/index";
        case "settings":
           return baseURL + "/user/settings";
        case "approval":
            return baseURL + "/approval/edit/" + value;
        case "survey":
            return baseURL + "/survey/edit/" + value;
        case "minutes":
            return baseURL + "/minute/edit/" + value;
        default:
            return baseURL;
      }

    }

    const getAgendaForSection = (agendaSectionId:number, tasks:boolean) => {
      MeetingApi.getMeetingIdFromAgenda(profile?.companyId,agendaSectionId).then(result => 
        {
          let id = parseInt(result)
          if(id > 0) {
            let path = `/company/${profile?.companyId}/meetings/${id}/${tasks ? "tasks" : "agenda"}`
            window.location.href = path
          } else {
            window.location.href = `/company/${profile?.companyId}`
          }
        }).catch(error => {
          Logger().error("could not find meeting",error)
          window.location.href = `/company/${profile?.companyId}`
        })
    }

    const getTask = (taskId:number) => {
      TaskApi.getTask(profile?.companyId,taskId).then(result => 
        {
          if(result.associatedSectionId != 0) {
            window.location.href = `/company/${profile?.companyId}/meeting/agenda/${result.associatedSectionId}/tasks`
          } else {
            window.location.href = `/company/${profile?.companyId}`
          }

        }).catch(error => {
          Logger().error("could not find task",error)
          window.location.href = `/company/${profile?.companyId}`
        })
    }


    const getMinutesForId = (minutesId:number) => {
      MinutesApi.getMeetingIdFromMinute(profile?.companyId,minutesId).then(result => 
        {
          if(result > 0) {
            let path = `/company/${profile?.companyId}/meetings/${result}/minutes`
            window.location.href = path
          } else {
            window.location.href = `/company/${profile?.companyId}`
          }
        }).catch(error => {
          Logger().error("could not find meeting",error)
          window.location.href = `/company/${profile?.companyId}`
        })
    }

    
  return (<div style={{width: '100%',padding: 50}}><Spin><Row><Col span={24}></Col></Row></Spin></div>);
}

export default RedirectHandler;
